import SubResult from "../models/subresult";

class Result {
    requestId : string = "";
    subResults : SubResult[] = [];
}

export default Result;